module.exports = __webpack_public_path__ + "static/media/pic10.a132d619.jpg";